import { Component, Input } from '@angular/core';
import { ComAcLevelsGridLayoutService } from '@irb/irb-editors/editor-security/com-ac-levels/com-ac-levels.grid-layout.service';
import { ISecurityACLevel } from '@irb/irb-models/irb-models.model';
import { SecurityMasterService } from '@irb/irb-models/security-master/security-master.service';

@Component({ standalone: false,
  selector: 'irb-com-ac-levels',
  templateUrl: './com-ac-levels.component.html',
  styleUrl: './com-ac-levels.component.scss'
})
export class ComAcLevelsComponent {
  @Input("id") id: number;
  data: Array<ISecurityACLevel> = [];
  grid: any;
  gridOptions: any;
  footerContent: string;

  constructor(private gls: ComAcLevelsGridLayoutService, private sms: SecurityMasterService) {}

  ngOnInit(): void {
      this.gridOptions = {
        columnDefs: this.gls.getColumnDefs(),      
        floatingFilter: false,
        context: { componentParent: this }
      };      

      this.sms.getSecurityACLevels(this.id).subscribe((response: any) => {
        this.data = response?.data?.irebalResponse || [];

        if(this.data.length == 0) {
          this.data = [
            {acLevel1: "None", acLevel2: "None", acLevel3: "None", acLevel4: "None"}
          ];
        }

        this.footerContent = this.data.length + " asset classes";
      });
  }

  onGridReady(params: any) {
    this.grid = params;
  }
}
